import type { Language } from '@/utils/language.ts'
import { useMemo } from 'react'
import { NavLink } from 'react-router-dom'

type Props = {
  language: Language
  setLanguage?: (language: Language) => void
  selectLanguageEnabled?: boolean
}

const LandingHeader = ({ language, setLanguage, selectLanguageEnabled = true }: Props) => {
  const loginButtonName = useMemo(() => {
    switch (language) {
      case 'ko':
        return '로그인'
      case 'jp':
        return 'ログイン'
      default:
        return 'Login'
    }
  }, [language])

  return (
    <header className="flex items-center justify-between py-10" aria-label="landing-header">
      <img className="h-6" alt="logo" src="/images/logo.svg" aria-label="logo" />
      <div className="flex items-center gap-4">
        {selectLanguageEnabled && (
          <div className="flex items-center justify-between w-[130px] h-11 px-4 py-2.5 bg-white rounded-[10px] border border-solid border-[#d1d1d1]">
            <select
              name="language"
              id="language"
              aria-label="language"
              className="[font-family:'Pretendard-Regular',Helvetica] font-normal text-[#283139] text-sm"
              value={language}
              onChange={(event) => {
                if (setLanguage) {
                  setLanguage(event.target.value as Language)
                }
              }}
            >
              <option value="ko">한국어</option>
              <option value="jp">日本語</option>
              <option value="en">English</option>
            </select>
            <img src="/images/select-box.svg" alt="select-box" />
          </div>
        )}
        <NavLink
          to="/login"
          className="flex justify-center items-center text-white w-[100px] py-3 px-4 bg-[#34495e] rounded-[10px] font-bold text-[1rem] leading-[120%]"
        >
          {loginButtonName}
        </NavLink>
      </div>
    </header>
  )
}
export default LandingHeader
